module.exports = __webpack_public_path__ + "static/img/notfound.5402cfc8.jpg";